import React, { createContext, useContext, useEffect, useState } from 'react';
import GlobalLoadingOverlay from '../components/Loading/LoadingOverlay';

const LoadingContext = createContext(null);

export const loadingController = {
  show: () => {},
  hide: () => {},
};

export const LoadingProvider = ({ children }) => {
  const [count, setCount] = useState(0);
  const isLoading = count > 0;

  const showLoading = () => {
    setCount((prev) => prev + 1);
  };

  const hideLoading = () => {
    setCount((prev) => Math.max(0, prev - 1));
  };

  useEffect(() => {
    loadingController.show = showLoading;
    loadingController.hide = hideLoading;
  }, []);

  return (
    <LoadingContext.Provider value={{ showLoading, hideLoading }}>
      {children}
      {isLoading && <GlobalLoadingOverlay />}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
